import { inject, Injectable } from '@angular/core';
import { EVERYDAY_SPEND_ENABLED } from '@features/everyday-spend/tokens/unleash-flags.token';
import { FeatureFlagService } from '@rd/core/services/feature-flag/feature-flag.service';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { FeatureFlags, NavLink } from '@rd/types';
import { PageUrlSegment } from '../types';

export const home: NavLink = {
  translationKey: 'wl.anz.header.home',
  route: '/',
};

export const redeem: NavLink[] = [
  {
    translationKey: 'wl.anz.header.gift_cards',
    route: '/gift_card/listing',
    dataTestid: 'anz-header-menu-navlink-gift-card',
  },
  // Add new NavLink object to Airline Partners
  {
    translationKey: 'wl.anz.header.cash_back',
    route: '/redeem_cash/checkout',
    dataTestid: 'anz-header-menu-navlink-cash-back',
  },
  {
    translationKey: 'wl.anz.header.airline_partners',
    route: '/transfer/programs',
    dataTestid: 'anz-header-menu-navlink-airline-partners',
  },
];
const merchandiseRoute = {
  translationKey: 'wl.anz.header.rewards_store',
  route: PageUrlSegment.MERCHANDISE,
  dataTestid: 'anz-header-menu-navlink-rewards-store',
};
const everydaySpendRoute = {
  translationKey: 'Everyday Rewards',
  route: '/everyday_rewards/checkout',
  dataTestid: 'anz-header-menu-navlink-everyday-spend',
};

export const staticPages: NavLink[] = [
  {
    translationKey: 'wl.anz.header.contact_us',
    route: '/contact_us',
  },
  {
    translationKey: 'wl.anz.header.faq',
    route: '/faq',
  },
  {
    translationKey: 'wl.anz.header.terms_and_conditions',
    route: '/terms_of_use',
  },
  {
    translationKey: 'wl.anz.header.security_and_privacy_statement',
    route: '/privacy_policy',
  },
];

@Injectable({
  providedIn: 'root',
})
export class AnzNavLinksService {
  private isEverydaySpendEnabled = inject(EVERYDAY_SPEND_ENABLED);

  home = home;
  redeem = [
    ...redeem,
    ...(this.featureFlagService.isEnable(FeatureFlags.Merchandise)
      ? [merchandiseRoute]
      : []),
    ...(this.isEverydaySpendEnabled ? [everydaySpendRoute] : []),
  ];
  staticPages = [
    ...staticPages,
    {
      translationKey: 'wl.anz.header.anz_link',
      route: 'https://www.anz.com.au/personal/',
    },
  ];
  rewards = [
    {
      translationKey: 'wl.anz.header.points_transaction',
      route: '/points_activity',
      dataTestid: 'anz-header-menu-navlink-points-transaction',
    },
    {
      translationKey: 'wl.anz.header.my_redemptions',
      route: this.featureFlagService.isEnable(FeatureFlags.AutoRedemption)
        ? '/orders/past-redemptions'
        : '/orders',
      dataTestid: 'anz-header-menu-navlink-my-redemption',
    },
    {
      translationKey: 'wl.anz.header.my_profile',
      route: this.guardhouseService.profileUrl.toString(),
      dataTestid: 'anz-header-menu-navlink-my-profile',
    },
  ];

  constructor(
    protected guardhouseService: GuardhouseService,
    private featureFlagService: FeatureFlagService,
  ) {}
}
